var UtilCoopProject = /** @class */ (function () {
    function UtilCoopProject() {
        this.getProjectDifficultyLevelType = function (coopProject, difficulty) {
            var result;
            if (coopProject && difficulty) {
                result = coopProject.difficultyLevel.find(function (difficultyLevelType) { return difficultyLevelType.level === difficulty; });
            }
            return result;
        };
    }
    return UtilCoopProject;
}());
export var utilCoopProject = new UtilCoopProject();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilCoopProject.ts
// module id = 332
// module chunks = 3